export function clamp(n, min, max) {
  return Math.min(Math.max(n, min), max);
}

export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min;
}
